var sections = document.querySelectorAll('.offers-panel-section')
sections.forEach((section) => {
  var altDiscountName = '';
  var getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  
  var updateButtons = function(section){
    var existingDiscount = getCookie("discount_code") || altDiscountName;
    section.querySelectorAll('[data-discount]').forEach(button => {
      var appliedText = button.nextElementSibling  
      if((existingDiscount && button.dataset.discount === existingDiscount) && !button.classList.contains('disabled')){
        button.style.display = 'none'
        appliedText.classList.remove('hide')
        if(!document.querySelector('#side-cart.open')) section.querySelector('[data-expand-trigger]').click()
      } else {
        button.style.display = ''
        appliedText.classList.add('hide')
      }
    })
  }

  updateButtons(section)

  document.addEventListener('shopifyCartChanged', function(e) {
    var cart = e.detail;
    section.querySelectorAll('[data-amount]').forEach(button => {
      var threshold = parseInt(button.dataset.amount)
      if( cart.total_price < threshold ){
        button.classList.add('disabled')
        button.href = '#';
      }else{
        button.classList.remove('disabled')
        button.href = button.dataset.url;
      }
    })
    setTimeout(updateButtons(section),100)    
  });  
})